module.exports = __webpack_public_path__ + "static/media/AgreementM.82692bc5.svg";